webpackJsonp([226020273838829],{

/***/ 420:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTQgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ2LjIgKDQ0NDk2KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT50aWNrPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9InRpY2siIHRyYW5zZm9ybT0idHJhbnNsYXRlKDYuNzE3NTE0LCA0LjcxNzUxNCkgcm90YXRlKDQ1LjAwMDAwMCkgdHJhbnNsYXRlKC02LjcxNzUxNCwgLTQuNzE3NTE0KSB0cmFuc2xhdGUoMy4yMTc1MTQsIC0xLjI4MjQ4NikiIGZpbGw9IiM1REUyRjkiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSItOC44ODE3ODQyZS0xNiIgeT0iOSIgd2lkdGg9IjQiIGhlaWdodD0iMyI+PC9yZWN0PgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLUNvcHkiIHg9IjMuNTg1Nzg2NDQiIHk9Ii0xLjc3NjM1Njg0ZS0xNSIgd2lkdGg9IjMiIGhlaWdodD0iMTIiPjwvcmVjdD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(23);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(54);
	
	var _palette = __webpack_require__(17);
	
	var _palette2 = _interopRequireDefault(_palette);
	
	var _navbar = __webpack_require__(44);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _btnsShared = __webpack_require__(90);
	
	var _mobileContent = __webpack_require__(70);
	
	var _mobileContent2 = _interopRequireDefault(_mobileContent);
	
	var _tick = __webpack_require__(420);
	
	var _tick2 = _interopRequireDefault(_tick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STYLES = _extends({
	  pricingContainer: {
	    maxWidth: 1440,
	    minHeight: 'calc(100vh - 50px)',
	    display: 'flex',
	    alignItems: 'flex-start',
	    justifyContent: 'center',
	    flexDirection: 'row',
	    margin: '150px auto 0',
	    fontSize: 20,
	    '@media screen and (max-width: 1000px)': {
	      display: 'block'
	    }
	  },
	  priceCard: {
	    position: 'relative',
	    width: '30%',
	    margin: '0 16px',
	    backgroundColor: _palette2.default.COAL,
	    color: _palette2.default.ROCK,
	    borderRadius: 7,
	    padding: '10px 31px 27px',
	    boxShadow: '0 27px 100px 6px rgba(24,0,8,0.17)',
	    '@media screen and (max-width: 1000px)': {
	      width: '100%',
	      position: 'relative',
	      transform: 'none',
	      top: 0,
	      left: 0,
	      margin: '30px auto 0 auto',
	      backgroundColor: 'transparent',
	      boxShadow: 'none',
	      color: _palette2.default.SUNSTONE
	    }
	  },
	  title: {
	    fontSize: 28,
	    textAlign: 'center',
	    width: '100%',
	    color: _palette2.default.SUNSTONE,
	    marginBottom: -30
	  },
	  label: {
	    textAlign: 'center',
	    fontStyle: 'italic',
	    marginTop: 12,
	    fontSize: 17
	  },
	  sectionTitle: {
	    color: _palette2.default.LIGHT_BLUE,
	    fontSize: 18
	  },
	  priceSticker: {
	    position: 'absolute',
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    flexDirection: 'column',
	    width: 80,
	    height: 80,
	    right: -27,
	    top: -23,
	    fontSize: 28,
	    backgroundColor: _palette2.default.LIGHTEST_PINK,
	    borderRadius: '50%',
	    color: _palette2.default.SUNSTONE,
	    '@media screen and (max-width: 1000px)': {
	      display: 'none'
	    }
	  },
	  priceStickerLabel: {
	    fontSize: 11,
	    fontStyle: 'italic',
	    textAlign: 'center',
	    marginTop: -7
	  },
	  link: {
	    color: _palette2.default.LIGHT_BLUE,
	    textDecoration: 'none'
	  },
	  ul: {
	    listStyle: 'none',
	    marginLeft: 0,
	    marginTop: 35,
	    marginBottom: 30,
	    paddingLeft: '1em',
	    textIndent: '-1em',
	    lineHeight: 1.3,
	    textAlign: 'left'
	  },
	  li: {
	    paddingLeft: 10,
	    fontSize: 18
	  },
	  btnCTA: {
	    display: 'block',
	    textAlign: 'center',
	    backgroundColor: _palette2.default.LIGHTEST_PINK
	  },
	  h3: {
	    fontSize: 11
	  }
	}, _btnsShared.BTN_STYLES);
	
	var Pricing = function (_Component) {
	  _inherits(Pricing, _Component);
	
	  function Pricing() {
	    _classCallCheck(this, Pricing);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Pricing.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Plans & Pricing | Haiku'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'Haiku is 100% free to use while we\'re in Preview. Your projects will always belong to you.' }),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'Plans & Pricing | Haiku' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: 'Haiku is 100% free to use while we\'re in Preview. Your projects will always belong to you.' })
	      ),
	      _react2.default.createElement(_navbar2.default, null),
	      _react2.default.createElement(
	        'div',
	        { style: STYLES.pricingContainer },
	        _react2.default.createElement(
	          'div',
	          { style: STYLES.priceCard },
	          _react2.default.createElement(
	            'h1',
	            { style: STYLES.title },
	            'Haiku Is Free'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { style: STYLES.ul },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'Unlimited Public Projects on Haiku Cloud (sharing and versioned storage)'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'Project files always available offline'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'Code export (React, Angular, Vue, iOS, Android)'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'GIF export (medium quality)'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'Drawing tool integration (Figma, Sketch, Adobe Illustrator)'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'Open source core (renderer + file format)'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'Required internet connection for app use'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'Publish required for code & GIF exports'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'Invite collaborators to any project (coming soon*)'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: ("https://account.haiku.ai") + '/new' },
	            _react2.default.createElement(
	              'div',
	              { key: 'cta10', style: [STYLES.btn, STYLES.cta, STYLES.btnCTA] },
	              'Get Haiku'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: STYLES.priceCard },
	          _react2.default.createElement(
	            'div',
	            { style: STYLES.priceSticker },
	            _react2.default.createElement(
	              'div',
	              null,
	              '$19'
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: STYLES.priceStickerLabel },
	              '/mo*'
	            )
	          ),
	          _react2.default.createElement(
	            'h1',
	            { style: STYLES.title },
	            'Haiku Pro'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { style: STYLES.ul },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'Includes everything in Haiku Free'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'Unlimited Private & Public Projects on Haiku Cloud (sharing and versioned storage)'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'Full offline support'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'GIF export (high quality)'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'Video export'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'Design + code version control (coming soon)'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://account.haiku.ai/checkout', key: 'cta11', style: [STYLES.btn, STYLES.cta, STYLES.btnCTA] },
	            'Go Pro'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: STYLES.label },
	            '*Annual discount available'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: STYLES.priceCard },
	          _react2.default.createElement(
	            'h1',
	            { style: STYLES.title },
	            'Haiku For Teams'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { style: STYLES.ul },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'Includes everything in Haiku Free + Pro'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'Centralized project & access control'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'Real-time collaboration'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement('img', { src: _tick2.default, alt: 'tick' }),
	              _react2.default.createElement(
	                'span',
	                { style: STYLES.li },
	                'Design + code version control'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { key: 'cta9', style: [STYLES.btn, STYLES.cta, STYLES.btnCTA] },
	            _react2.default.createElement(
	              'a',
	              { style: { color: _palette2.default.SUNSTONE }, href: 'mailto:contact@haiku.ai?subject=Enterprise Pricing' },
	              'Please Contact'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_mobileContent2.default, null)
	    );
	  };
	
	  return Pricing;
	}(_react.Component);
	
	exports.default = (0, _radium2.default)(Pricing);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pricing-js-92a68c0717aae0165a26.js